<template>
  <div class="app-dropdown" v-click-outside="close" :class="{'app-dropdown_active': active}">
    <div class="app-dropdown__body" @click="toggleOpen" ref="content">
      <slot />
    </div>

    <div class="app-dropdown__menu" ref="appDropdownMenu" v-show="active" :style="style" :class="menuClass">
      <div class="app-dropdown__menu-content">
        <slot name="menu" />
      </div>
    </div>

  </div>
</template>

<script>
import utils from "@/assets/utils";

export default {
  name:    "AppDropdown",
  props:   {
    menuClass: {},
    position:  {
      default: 'right',
    },
  },
  data() {
    return {
      active: false,
      style:  {
        left: 0,
        top:  0,
      },
    };
  },
  methods: {
    changePosition() {
      let elx = this.$refs.content;
      let content = this.$refs.appDropdownMenu;
      let topx = 0;
      let leftx = 0;
      let scrollTopx = window.pageYOffset || document.documentElement.scrollTop;
      let scrollLeftx = window.pageXOffset || document.documentElement.scrollLeft;
      const rect = elx.getBoundingClientRect();
      if (rect.top + content.scrollHeight + 20 >= window.innerHeight) {
        topx = rect.top + elx.clientHeight + scrollTopx - content.scrollHeight;
      } else {
        topx = rect.top + scrollTopx + elx.scrollHeight;
      }
      if (this.position === 'left') {
        leftx = rect.left + scrollLeftx - content.scrollWidth;
      } else if (this.position === 'center') {
        if (rect.left + content.scrollWidth + 20 >= window.innerWidth) {
          leftx = rect.left + (elx.clientWidth / 4) + scrollLeftx - content.scrollWidth;
        } else {
          leftx = rect.left - (Math.abs(elx.clientWidth - content.scrollWidth) / 2) + scrollLeftx;
        }
      } else {
        if (rect.left + content.scrollWidth + 20 >= window.innerWidth) {
          leftx = rect.left + elx.clientWidth + scrollLeftx - content.scrollWidth;
        } else {
          leftx = rect.left + scrollLeftx;
        }
      }


      if (leftx < 5) {
        leftx = 5;
      }

      this.style = {
        left: `${leftx}px`,
        top:  `${topx}px`,
      };
    },
    toggleOpen() {
      this.active = !this.active;

      if (this.active) {
        this.$nextTick(() => {
          utils.insertBody(this.$refs.appDropdownMenu);
          this.$nextTick(() => {
            this.changePosition();
          });
        });
      } else {
        this.close();
      }
    },
    close() {
      let [parent] = document.getElementsByTagName("body");
      if (parent.contains(this.$refs.appDropdownMenu)) {
        parent.removeChild(this.$refs.appDropdownMenu);
      }
      this.active = false;
    },
  },
  mounted() {
    this.$refs.appDropdownMenu.remove();
    window.addEventListener('scroll', this.changePosition);
  },
  beforeDestroy() {
    this.close();
    window.removeEventListener('scroll', this.changePosition);
  },
};
</script>

<style lang="scss">
.app-dropdown {
  position: relative;

  &__menu {
    position: absolute;
    padding-top: 5px;
    height: auto;
    width: auto;
    right: 0;
    top: 100%;
    max-width: calc(100% - 10px);
    z-index: 10001;
  }

  &__menu-content {
    background: #fff;
    border-radius: 2px;
    box-shadow: 0 1px 15px 1px rgba(0, 0, 0, .04), 0 1px 6px rgba(0, 0, 0, .08);
    /*border: 1px solid rgba(0, 0, 0, .125);*/
    padding: 5px;
    position: relative;
    margin: 0;
    animation: dropdown-move .4s ease-out 1 both;
  }
}

@keyframes dropdown-move {
  0% {
    transform: translateY(-10%);
    opacity: .2;
  }

  100% {
    transform: translateY(0);
    opacity: 1;
  }
}
</style>
